"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";
// Removed next-themes since it might cause issues if not wrapped in provider

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light" // or handle dynamically via props if needed
      className="toaster group"
      closeButton
      duration={3000}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--toast-duration": "5000ms"
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
